import api from './axiosInstance';

function getUserId() {
  try { return JSON.parse(localStorage.getItem('user'))?.id ?? null; } catch { return null; }
}

export const getDailyExpensesApi   = (params)    => api.get('/daily-expense', { params, headers: { user_id: getUserId() } });
export const getIncomeSourcesApi   = (params)    => api.get('/daily-expense/incomes', { params, headers: { user_id: getUserId() } });
export const createDailyExpenseApi = (data)      => api.post('/daily-expense', data, { headers: { user_id: getUserId() } });
export const updateDailyExpenseApi = (id, data)  => api.put(`/daily-expense/${id}`, data, { headers: { user_id: getUserId() } });
export const confirmDailyExpenseApi = (id)       => api.patch(`/daily-expense/${id}/confirm`, {}, { headers: { user_id: getUserId() } });
export const deleteDailyExpenseApi = (id)        => api.delete(`/daily-expense/${id}`, { headers: { user_id: getUserId() } });

export const getDailyExpenseCategoriesApi  = (params)    => api.get('/daily-expense/category', { params });
export const createDailyExpenseCategoryApi = (data)      => api.post('/daily-expense/category', data,    { headers: { user_id: getUserId() } });
export const updateDailyExpenseCategoryApi = (id, data)  => api.put(`/daily-expense/category/${id}`, data, { headers: { user_id: getUserId() } });
export const deleteDailyExpenseCategoryApi = (id)        => api.delete(`/daily-expense/category/${id}`,    { headers: { user_id: getUserId() } });
